export interface OAuthRequestInfo {
	client_name: string;
	callback_host: string;
	scopes: string[];
	requested_at: string;
	expires_at: string;
	can_connect: boolean;
}

export interface OAuthConnection {
	family_id: string;
	user_id: string;
	firstname: string | null;
	lastname: string | null;
	email: string;
	client_id: string;
	client_name: string;
	issued_at: string;
	last_used_at: string | null;
	scopes: string[];
}

/** Plain-words reading of each scope. An unknown scope shows its raw name. */
export const SCOPE_LABELS: Record<string, string> = {
	read: "Read what your account can see",
	docs: "Search the how-to docs",
	receipts: "Receipts",
	"reconciliation-write": "Reconciliation changes",
};

export const scopeLabel = (scope: string): string => SCOPE_LABELS[scope] ?? scope;
